export const queryKey = {
  alarmSettings: () => ['alarmSettings'],
  beautyInfo: () => ['beautyInfo'],
  marketingAlarmSettings: () => ['marketingAlarmSettings'],
  pocList: () => ['pocList'],
};
